import PicklistRadioGroup from 'Components/UI/Radio/PicklistRadioGroup';
import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

const BaseOverrideNoHiddenWithRadioGroupPicklist = fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ type: 'picklist' }, { _component: () => PicklistRadioGroup });

export default BaseOverrideNoHiddenWithRadioGroupPicklist;
